
import React, { useState, useEffect, useCallback } from "react";
import { View, StyleSheet, TouchableHighlight, Button, TouchableNativeFeedback } from "react-native";
//import { MaterialCommunityIcons } from "@expo/vector-icons";
//import Swipeable from "react-native-gesture-handler/Swipeable";
//import AutogrowInput from 'react-native-autogrow-input';
import connectionConfig from "../../config/settings";
import { Video, Audio, AVPlaybackStatus } from 'expo-av';
import { Image } from "react-native-expo-image-cache";


import Text from "../Text";
import colors from "../../config/colors";
import { TouchableOpacity } from "react-native-gesture-handler";
//import { color } from "react-native-reanimated";
//import { WebView } from 'react-native-webview';
import dateNow from "../../utility/dateNow";

const webUrl = connectionConfig.imageUrl + '/chatImages/'
var seedVideoUri = connectionConfig.imageUrl + '/chatVideos/'
var dateChange = ''
var currentDay = ''
const date = dateNow();
//var displayDate = ''
var dateRow = ''

function ChatListItem({
  title,
  contentChatBox,
  titleFollowers,
  subTitleFollowers,
  titleFollowed,
  subTitleFollowed,
  dateContentChat,
  displayDate,
  image,
  IconComponent,
  onPress,
  onPress1,
  onPressGenerateSeed,
  detailsContainerLeft,
  uriLocation,
  chatImage,
  textCut
}) {
  //debugger
  useEffect(() => {
    console.log('entre al effect textCut ->', textCut)
    // activate()
    // dateRow = dateContentChat.substring(0, 4) +
    //   dateContentChat.substring(5, 7) +
    //   dateContentChat.substring(8, 10)
    // currentDay = date.substring(0, 11).replace('/', '').replace('/', '')
    // if (dateChange != dateRow) {
    //   displayDate = compareDate(dateRow, currentDay)
    // } else {
    //   displayDate = ''
    // }
    // console.log('displayDate -> ', displayDate)
    // dateChange = dateRow
  }, []);

  var container = styles.container
  var containerR = styles.containerR
  var contentChatBox1 = styles.contentChatBox1
  var contentChatBox2 = styles.contentChatBox2
  var y = true

  const compareDate = (dateRow, currentDay) => {
    console.log('dateRow - ', dateRow, 'currentDay -', currentDay)
    var dif = parseInt(currentDay, 10) - parseInt(dateRow, 10)
    console.log('dif - ', dif)
    if (dif === 0) {
      return 'Hoy'
    }
    if (dif === 1) {
      return 'Ayer'
    }
    if (dif > 1) {
      return dateContentChat
    }
  }

  // variables necesarias para los videos:  
  //----------------------------------------
  const video = React.useRef(null);
  const [status, setStatus] = useState({});
  //----------------------------------------


  return (

      <View style={detailsContainerLeft === false ? container : containerR}>
    
        <View style={styles.detailsContainerLeft}>
        {/* <Text style={styles.dateChat}> {displayDate} </Text>  */}
       {
          textCut === '' ? 
          null   
            : <Text style={styles.dateChat}> {textCut} </Text>      
        } 

     
          
         
          { //  Bloque de validaciones de etiquetas para la ubicación
            uriLocation.trim().length > 0 ?
              <View >
                {/* <WebView
                  style={styles.map}
                  source={{ uri: uriLocation }}
                >
                </WebView> */}
                <Text
                  // defaultHeight={50}
                  onPress={onPressGenerateSeed}
                  //style={styles.contentChatBox1} 
                  style={detailsContainerLeft === false ? contentChatBox1 : contentChatBox2}
                >
                 algo de ubicacion
                </Text >
                <Text
                  // defaultHeight={50}
                  onPress={onPressGenerateSeed}
                  //style={styles.contentChatBox1} 
                  style={detailsContainerLeft === false ? contentChatBox1 : contentChatBox2}
                >
                  {contentChatBox + "\n"}

                  {dateContentChat.substring(11, 19)}
                </Text >

              </View>
              : chatImage != '' ?
                null
                :
                <Text
                  // defaultHeight={50}
                  onPress={onPressGenerateSeed}
                  //style={styles.contentChatBox1} 
                  style={detailsContainerLeft === false ? contentChatBox1 : contentChatBox2}

                >
                  {contentChatBox + "\n"}

                  {dateContentChat.substring(11, 19)}
                </Text >
          }

          {  // Bloque de validaciones de etiquetas para las imagenes
            chatImage.includes('.mp4') ?
              <View style={detailsContainerLeft === false ? contentChatBox1 : contentChatBox2}>
                <Video
                  ref={video}
                  style={styles.imageChat}
                  source={{ uri: seedVideoUri + chatImage }}
                  useNativeControls
                  resizeMode="contain"
                  isLooping
                  onPlaybackStatusUpdate={status => setStatus(() => status)}
                />
                <Text
                  onPress={onPressGenerateSeed}
                  //style={styles.contentChatBox2} 
                  //numberOfLines={5}
                  style={detailsContainerLeft === false ? contentChatBox1 : contentChatBox2}
                //defaultHeight={50}
                >
                  {contentChatBox + "\n"}
                  {dateContentChat.substring(11, 19)}
                </Text >
              </View>
              :
              chatImage.includes('.mov') ?
                <View style={detailsContainerLeft === false ? contentChatBox1 : contentChatBox2}>
                  <Video
                    ref={video}
                    style={styles.imageChat}
                    source={{ uri: seedVideoUri + chatImage }}
                    useNativeControls
                    resizeMode="contain"
                    isLooping
                    onPlaybackStatusUpdate={status => setStatus(() => status)}
                  />
                  <Text
                    onPress={onPressGenerateSeed}
                    //style={styles.contentChatBox2} 
                    //numberOfLines={5}
                    style={detailsContainerLeft === false ? contentChatBox1 : contentChatBox2}
                  // defaultHeight={50}
                  >
                    {contentChatBox + "\n"}
                    {dateContentChat.substring(11, 19)}
                  </Text >
                </View>
                :
                chatImage === '' ?
                  null
                  :
                  chatImage.includes('.png') ?
                    <View style={detailsContainerLeft === false ? contentChatBox1 : contentChatBox2}>
                      <Image
                        style={styles.imageChat}
                        preview={{ uri: webUrl + chatImage }}
                        tint="light"
                        uri={webUrl + chatImage}
                      />
                      <Text
                        onPress={onPressGenerateSeed}
                        //style={styles.contentChatBox2} 
                        //numberOfLines={5}
                        style={detailsContainerLeft === false ? contentChatBox1 : contentChatBox2}
                      //defaultHeight={50}
                      >
                        {contentChatBox + "\n"}
                        {dateContentChat.substring(11, 19)}
                      </Text >
                    </View>
                    : chatImage.includes('.jpg') ?
                      <View style={detailsContainerLeft === false ? contentChatBox1 : contentChatBox2} >
                        <Image
                          style={styles.imageChat}
                          preview={{ uri: webUrl + chatImage }}
                          tint="light"
                          uri={webUrl + chatImage}
                        />
                        <Text
                          onPress={onPressGenerateSeed}
                          style={detailsContainerLeft === false ? contentChatBox1 : contentChatBox2}
                        //numberOfLines={5}
                        // defaultHeight={50}
                        >
                          {contentChatBox + "\n"}
                          {dateContentChat.substring(11, 19)}
                        </Text >
                      </View>
                      :
                      null
          }
        </View>
{/* 
        <TouchableOpacity onPress={onPress}>
          <View style={styles.detailsContainerLeft}>
            <Text
              style={styles.titleFollowed}
              numberOfLines={1}
            >
              {titleFollowed}
            </Text>
            {subTitleFollowed && (
              <Text style={styles.dateContentChat} numberOfLines={2}>
                {subTitleFollowed}
              </Text>
            )}
          </View>
        </TouchableOpacity>
        <TouchableHighlight onPress={onPress1}>
          <View style={styles.detailsContainerLeft}>
            <Text style={styles.titleFollowers} numberOfLines={1}>
              {titleFollowers}
            </Text>
            {dateContentChat && (
              <Text style={styles.dateContentChat} numberOfLines={2}>
                {subTitleFollowers}
              </Text>
            )}
          </View>
        </TouchableHighlight> */}
      </View>
   

  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flexDirection: "row",
    padding: 15,
    //backgroundColor: colors.white,
  },
  containerR: {
    alignItems: "center",
    flexDirection: "row-reverse",
    padding: 15,
    //backgroundColor: colors.white,
  },
  detailsContainerLeft: {
    marginLeft: '1%',
    justifyContent: "center",
  },
  detailsContainerRight: {
    marginRight: '2%',
    justifyContent: "center",
  },
  image: {
    marginTop: 15,
    marginRight: "5%",
    width: 50,
    height: 50,
    borderRadius: 35,
  },
  imageChat: {
    //marginTop: 15,
    //marginRight: "5%",
    width: 300,
    height: 300,
    //borderRadius: 35,
  },
  imageButton: {
    backgroundColor: 'yellow',
    width: 70,
    height: 70,
    borderRadius: 35,
  },
  dateContentChat: {
    color: colors.medium,
    textAlign: 'center'
  },
  title: {
    fontWeight: "500",
  },
  subTitleContainer: {
    width: "100%",
    height: "1%",
  },
  contentChatBox1: {
    backgroundColor: colors.pistache,
    borderRadius: 5,
    color: colors.medium
  },
  contentChatBox2: {
    backgroundColor: colors.medium,
    borderRadius: 5,
    color: colors.white

  },
  dateChat: {
    //  marginBottom: 15,
    backgroundColor: colors.dark,
    borderRadius: 5,
    color: colors.white
  },
  map: {
    width: 300,
    height: 300
  }
});

export default ChatListItem;
